<template>
<div class="offer_cont wrapper">
  <h4>応募概要</h4>
  <dl>
    <dt>応募期間</dt>
    <dd>2020年11月1日（日）9:00～2021年1月31日（日）17:00</dd>
  </dl>
  <dl>
    <dt>応募方法</dt>
    <dd>キャンペーン専用ページより、あなたのMyユンケルを全36製品の中からお選びいただき、応募フォームに必要事項およびアンケートの回答をご入力の上、ご応募ください。本キャンペーンは、お１人様1回の応募（投票）となります。</dd>
  </dl>
  <dl>
    <dt>景品</dt>
    <dd>
      <ul>
        <li>・ワイヤレス充電器（サトちゃん・サトコちゃんデザイン） 20名様</li>
        <li>・オリジナルコインバンク（サトちゃん・サトコちゃんセット） 30名様<br>総計50名様</li>
      </ul>
    </dd>
  </dl>
  <dl>
    <dt>抽選</dt>
    <dd>キャンペーン終了後、厳選な抽選の上、当選者を決定いたします。
    </dd>
  </dl>
  <dl>
    <dt>当選発表</dt>
    <dd>厳正な抽選の上、景品の発送をもって当選者の発表に代えさせていただきます。<br>景品の発送は2月下旬～3月上旬を予定しております。</dd>
  </dl>
  <dl>
    <dt>応募規約</dt>
    <dd>
      <ul>
        <li>・ご応募はご本人限りとさせていただきます。</li>
        <li>・景品の発送は日本国内に限らせていただきます。</li>
        <li>・当選者のメールアドレス、住所、転居先が不明等で景品がお届けできない場合は、当選を無効とさせていただきます。</li>
        <li>・郵送時等の事故につきましては、一切責任を負いかねます。</li>
        <li>・景品の交換、換金、返品、当選権利の譲渡は応じかねますので、予めご了承ください。</li>
        <li>・佐藤製薬社員とその家族、および本キャンペーンの関係者の応募はご遠慮ください。</li>
        <li>・個人情報の観点から下記に記載してある「個人情報の取扱いについて」を必ず一読いただき同意の上、ご応募ください。</li>
        <li>・当選者の発表は、景品の発送をもって代えさせていただきます。電話やメールでの当選結果のご質問にはお答えできませんので、ご了承ください。</li>
        <li>・アクセス集中時は、つながりにくい場合があります。</li>
      </ul>
    </dd>
  </dl>
  <dl>
    <dt>個人情報の取り扱いについて</dt>
    <dd>本キャンペーン応募の際にご入力いただいた個人情報は、抽選、景品の発送、個人を特定しない統計的情報のみに活用いたします。それ以外の目的には一切使用いたしません。応募者様の個人情報を応募者様の同意無しに業務委託先以外の第三者に開示・提供することはございません（法令等により開示を求められた場合を除く）。本キャンペーンへのお申込みに際して取得した個人情報は応募後、半年以内に破棄いたします（2021年7月末予定）。</dd>
  </dl>
</div>
</template>

<script>
export default {
  name: 'ApplicationOverview',
}
</script>
